module.exports = __webpack_public_path__ + "img/Picture7.8211bf45.png";